import axios from "../api/axios";
import config from '../config/configJS';

function SendData(data, path) {
  var promise = new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + path, JSON.stringify(data), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

  return promise;
}

// Jazyk aplikácie zvolený prihláseným používateľom — pamätá sa v účte (cz / sk / en)
export function setUserLanguage(language) {
  return SendData({ Language: language }, '/api/auth/Language');
}

export function getUserById(id) {
  return new Promise((resolve, reject) => {
    SendData({ 'id': id }, 'api/auth/GetById')
      .then((data) => {
        resolve(data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}

export function authenticateUser(UserEmail, Password) {
  return new Promise((resolve, reject) => {
    SendData(
      {
        UserEmail: UserEmail,
        Password: Password,
      },
      'api/auth/Authenticate'
    )
      .then((data) => {
        resolve(data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err); 
      });
  });
}

export function registerUser(fName, lName, email, pwd, roleId, teams) {
  return SendData({
        "Firstname": fName,
        "Lastname": lName,
        "UserEmail": email,
        "Password": pwd,
        "RoleId": roleId,
        "TeamIds" : teams
      }, '/api/auth/Register');
}

// includeInactive = aj deaktivovaní používatelia (prepínač v zozname)
export function getAllUsers(includeInactive = false) {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/auth/GetAll' + (includeInactive ? '?includeInactive=true' : ''), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function updateUser(id, fName, lName, pwd, roleId, teamIds) {
  return SendData({
    "Id": id,
    "FirstName": fName,
    "LastName": lName,
    "Password": pwd,
    "RoleId": roleId,
    "TeamIds" : teamIds
  }, '/api/auth/UpdateUser');
}

export function searchUsers (name) {
  return SendData({ 
    "FirstName" : name,
  }, '/api/auth/GetByName');
}

// „vymazanie“ = deaktivácia účtu (dá sa obnoviť cez reactivateUser)
export function deleteUser(id) {
  return SendData({
    "Id": id
  }, '/api/auth/DeleteUserById');
}

export function reactivateUser(id) {
  return SendData({
    "Id": id
  }, '/api/auth/ReactivateUserById');
}

export function getAllRoles() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/auth/GetAllRoles', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function getAllAccesses() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/auth/GetAllAccesses', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function createTeam (name, userIds, envIds, adDn, accessIds) {
  return SendData({
    "Name": name,
    "UserIds": userIds,
    "EnvIds" : envIds,
    "AdDn": adDn,
    "AccessIds": accessIds
  }, '/api/auth/CreateTeam');
}

export function updateTeam (id, name, userIds, envIds, adDn, accessIds) {
  return SendData({
    "Id": id,
    "Name": name,
    "UserIds": userIds,
    "EnvIds" : envIds,
    "AdDn": adDn,
    "AccessIds": accessIds
  }, '/api/auth/UpdateTeam');
}

export function deleteTeam(id) {
  return SendData({
    "Id": id
  }, '/api/auth/DeleteTeam');
}

export function getTeamById (id) {
  return SendData({
    "Id": id
  },'/api/auth/GetTeamById');
}

export function isTokenValid(token) {
  if (token === undefined) {
    return false;
  } else {
    const dateToCompare = new Date(token.expires);
    const currentDate = new Date();
    const currentDatePlus2Hours = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
    if (dateToCompare > currentDatePlus2Hours) {
      return false;
    }
  }
  return true;
}
